<template>
  <div style="padding: 15px">
    <el-form ref="form" :rules="rules" :model="form" label-width="190px">
      <!-- 必填 -->
      <el-row>
        <el-col :span="24">
          <el-form-item
            label="上传证件"
            :required="
              !!requireData.identificationImg ||
                !!requireData.identificationBackImg ||
                !!requireData.driverImg ||
                !!requireData.driverLicenseImg ||
                !!requireData.workLicenseImg ||
                !!requireData.safeDutyInsureImg
            "
          >
            <ImgUpload
              :upload-config="{
                lebal: '实际承运人身份证人像面照片',
                prefix: 'identification',
                form: form,
                suffix: 'Img',
                modal: false
              }"
              :required="!!requireData.identificationImg"
              @handleImgSuccess="ficationImgSuccess"
            />
            <ImgUpload
              :upload-config="{
                lebal: '实际承运人身份证国徽面照片',
                prefix: 'identificationBack',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
              :required="!!requireData.identificationBackImg"
              @handleImgSuccess="ficationImgBackSuccess"
            />
            <ImgUpload
              :upload-config="{
                lebal: '实际承运人半身照',
                prefix: 'driver',
                form: form,
                suffix: 'Img',
                modal: false
              }"
              :required="!!requireData.driverImg"
            />
            <ImgUpload
              :upload-config="{
                lebal: '机动车驾驶证照片',
                prefix: 'driverLicense',
                form: form,
                suffix: 'Img',
                modal: false
              }"
              :required="!!requireData.driverLicenseImg"
              @handleImgSuccess="driverLicenseSuccess"
            />
            <ImgUpload
              :upload-config="{
                lebal: '道路运输从业资格证照片',
                prefix: 'workLicense',
                form: form,
                suffix: 'Img',
                modal: false
              }"
              :required="!!requireData.workLicenseImg"
              @handleImgSuccess="workLicenseSuccess"
            />
            <ImgUpload
              :upload-config="{
                lebal: '安全责任险照片',
                prefix: 'safeDutyInsure',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
              :required="!!requireData.safeDutyInsureImg"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="驾驶员姓名" prop="name">
            <el-input
              v-model.trim="form.name"
              placeholder="请输入驾驶员姓名"
              clearable
              @change="
                value => {
                  form.name = value.replace(/\s/g, '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col v-if="reportProvinceName == 'jiangsu'" :span="12">
          <el-form-item label="性别" prop="sex">
            <el-select v-model="form.sex" placeholder="请选择性别" clearable>
              <el-option :value="1" label="男" />
              <el-option :value="2" label="女" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系方式" prop="phone">
            <el-input
              v-model="form.phone"
              autocomplete="off"
              placeholder="请输入联系方式"
              clearable
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="密码" prop="password">
            <el-input
              v-model="form.password"
              type="password"
              autocomplete="new-password"
              placeholder="请输入密码，默认abcd1234"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="身份证号" prop="identificationNumber">
            <el-input
              v-model="form.identificationNumber"
              placeholder="请输入身份证号"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="身份证有效期" prop="idCardDueDate">
            <el-date-picker
              v-model="form.idCardDueDate"
              :class="form.hasDueDate ? 'disabledhide' : ''"
              type="date"
              placeholder="请选择身份证有效期"
              value-format="yyyy-MM-dd"
              clearable
              :disabled="form.hasDueDate"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="长期" label-width="60px">
            <el-checkbox
              v-model="form.hasDueDate"
              @change="
                value => {
                  this.$set(form, 'idCardDueDate', value ? '9999-12-31' : '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="通信地址" prop="areaList">
            <el-cascader
              v-model="form.areaList"
              :options="parentData.areaOptions"
              placeholder="请选择通信地址"
              :props="{
                value: 'countyCode',
                label: 'countyName',
                children: 'children'
              }"
              clearable
              @change="changeAreaList"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址" prop="homeAddress">
            <el-input
              v-model="form.homeAddress"
              placeholder="请输入详细地址"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工作单位" prop="workCompany">
            <el-input
              v-model="form.workCompany"
              placeholder="请输入工作单位"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="准驾类型" prop="vehicleClass">
            <el-select
              v-model="form.vehicleClass"
              placeholder="请选择准驾类型"
              clearable
            >
              <el-option
                v-for="item in parentData.vehicleTypeAllowList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="机动车驾驶证发证机关"
            prop="driverIssuingOrganizations"
          >
            <el-input
              v-model="form.driverIssuingOrganizations"
              placeholder="请输入机动车驾驶证发证机关"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="机动车驾驶证有效期自"
            prop="driverLicenseFromDate"
          >
            <el-date-picker
              v-model="form.driverLicenseFromDate"
              type="date"
              placeholder="请选择驾驶证有效期开始日期"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            label="机动车驾驶证有效期至"
            prop="driverLicenseDueDate"
          >
            <el-date-picker
              v-model="form.driverLicenseDueDate"
              :class="form.hasDriverDueDate ? 'disabledhide' : ''"
              type="date"
              placeholder="请选择驾驶证有效期结束日期"
              value-format="yyyy-MM-dd"
              clearable
              :disabled="form.hasDriverDueDate"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="长期" label-width="60px">
            <el-checkbox
              v-model="form.hasDriverDueDate"
              @change="
                value => {
                  this.$set(
                    form,
                    'driverLicenseDueDate',
                    value ? '9999-12-31' : ''
                  );
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="道路运输从业资格证到期日期"
            prop="workLicenseDueDate"
          >
            <el-date-picker
              v-model="form.workLicenseDueDate"
              type="date"
              placeholder="请选择道路运输从业资格证到期日期"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="机动车驾驶证号" prop="driverLicense">
            <el-input
              v-model="form.driverLicense"
              placeholder="请输入机动车驾驶证号"
              clearable
              @change="
                value => {
                  form.driverLicense = value.replace(/\W/g, '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="道路运输从业资格证号" prop="workLicense">
            <el-input
              v-model="form.workLicense"
              placeholder="请输入道路运输从业资格证号"
              clearable
              @change="
                value => {
                  form.workLicense = value.replace(/\W/g, '');
                }
              "
            />
            <div class="remarks">
              注:总质量4.5吨及以下普通货运车辆从事普通货物运输经营的驾驶员可填驾驶员身份证前6位+000000000000
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item>
            <el-button @click="funcCancel"> 取 消 </el-button>
            <el-button type="primary" @click="funcSubmit"> 确 定 </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { getDriverTeam, updateDriverTeam } from "@/api/driver";
import { validatePhone, validateIDNumber } from "@/utils/validate.js";
import { checkPassword } from "@/utils/validate4Form.js";
import { getOcr } from "@/api/shipment";
import ImgUpload from "@/components/ImgUpload";
import { findByFieldFrom } from "@/api/required";
import { realDay } from "@/utils/validate";

export default {
  name: "TeamDriverEdit",
  components: {
    ImgUpload
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          areaOptions: [],
          vehicleTypeAllowList: [],
          vehicleClassificationList: [],
          vehicleLengthList: [],
          vehicleWidthList: [],
          vehicleHighList: [],
          vehicleTonnageList: [],
          locationSourceList: []
        };
      }
    }
  },
  data() {
    return {
      areaList: [],
      teamCode: "",
      reportProvinceName: "",
      form: {},
      hisForm: {},
      ficationImgRes: {},
      driverLicenseRes: {},
      // 必填功能
      requireData: {},
      isAdmin: false,
      rules: {
        name: [
          { required: false, message: "请输入驾驶员姓名", trigger: "blur" },
          { max: 64, message: "最大长度为64个字符" }
        ],
        sex: [{ required: false, message: "请选择性别", trigger: "blur" }],
        phone: [
          {
            required: true,
            validator(rule, value, callback) {
              validatePhone(value)
                ? callback()
                : callback(new Error("请输入正确的联系方式"));
            },
            trigger: "blur"
          }
        ],
        password: [
          { required: false, message: "请输入密码", trigger: "blur" },
          { validator: checkPassword }
        ],
        identificationNumber: [
          {
            required: false,
            message: "请输入的身份证号",
            trigger: "blur"
          },
          {
            validator(rule, value, callback) {
              validateIDNumber(value)
                ? callback()
                : callback(new Error("请输入正确的身份证号"));
            },
            trigger: "blur"
          }
        ],
        idCardDueDate: [
          {
            required: false,
            message: "请选择身份证有效期",
            trigger: "change"
          }
        ],
        workCompany: [
          { required: false, message: "请输入工作单位", trigger: "blur" },
          { max: 128, message: "最大长度为128个字符" }
        ],
        driverIssuingOrganizations: [
          { required: false, message: "请输入驾驶证发证机关", trigger: "blur" },
          { max: 128, message: "最大长度为128个字符" }
        ],
        driverLicenseFromDate: [
          {
            required: false,
            message: "请选择驾驶证有效期开始日期",
            trigger: "change"
          }
        ],
        driverLicenseDueDate: [
          {
            required: false,
            message: "请选择驾驶证到期日期",
            trigger: "change"
          }
        ],
        workLicense: [
          {
            required: false,
            message: "请输入道路运输从业资格证号",
            trigger: "blur"
          },
          { max: 128, message: "最大长度为128个字符" }
        ],
        workLicenseDueDate: [
          {
            required: false,
            message: "请选择从业资格证到期日期",
            trigger: "change"
          }
        ],
        roadPermitNumber: [
          { required: false, message: "请输入道路运输证", trigger: "blur" },
          { max: 128, message: "最大长度为128个字符" }
        ],
        vehicleClass: [
          { required: false, message: "请选择准驾车型", trigger: "change" }
        ],
        driverLicense: [
          { required: false, message: "请输入机动车驾驶证号", trigger: "blur" },
          { max: 128, message: "最大长度为128个字符" }
        ],
        areaList: [
          { required: false, message: "请选择所在区域", trigger: "change" }
        ],
        homeAddress: [
          { required: false, message: "请输入详细地址", trigger: "blur" },
          { max: 255, message: "最大长度为255个字符" }
        ]
      }
    };
  },
  created() {
    this.reportProvinceName = this.reportProvince();
    const partyType = this.$store.getters.party.partyType;
    this.isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.teamCode = this.$route.query.partyCode
      ? this.$route.query.partyCode
      : "";
  },
  methods: {
    // 查询必填项
    async findByFieldFrom() {
      let response = await findByFieldFrom({ fieldFrom: "driver" });
      this.requireData = response.data;
      for (let key in this.requireData) {
        if (this.rules[key])
          this.rules[key][0].required = !!this.requireData[key];
      }
      this.rules.password[0].required = false;
    },
    getInfo(code) {
      this.findByFieldFrom();
      this.$refs.form.resetFields();
      getDriverTeam(code).then(response => {
        this.form = response.data;
        this.hisForm = response.data;
        this.$set(
          this.form,
          "hasDueDate",
          this.form.idCardDueDate == "9999-12-31"
        );
        this.$set(
          this.form,
          "hasDriverDueDate",
          this.form.driverLicenseDueDate == "9999-12-31"
        );
        this.form.areaList = [
          response.data.provinceCode,
          response.data.cityCode,
          response.data.countyCode
        ];
      });
    },
    // 区域切换
    changeAreaList(value) {
      if (value.length > 0) {
        this.form.provinceCode = value[0];
        this.form.cityCode = value[1];
        this.form.countyCode = value[2];
      } else {
        this.form.provinceCode = "";
        this.form.cityCode = "";
        this.form.countyCode = "";
      }
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          // const data = Object.assign({}, this.form, {
          //   teamCode: this.teamCode
          // });
          if (this.ficationImgRes.data && !this.driverLicenseRes.data) {
            if (
              this.ficationImgRes.data.name == this.hisForm.driverLicenseName
            ) {
              this.form.ocrResult = 0;
            } else {
              this.form.ocrResult = 1;
            }
          } else if (!this.ficationImgRes.data && this.driverLicenseRes.data) {
            if (this.driverLicenseRes.data.name == this.hisForm.name) {
              this.form.ocrResult = 0;
            } else {
              this.form.ocrResult = 1;
            }
          } else if (this.ficationImgRes.data || this.driverLicenseRes.data) {
            if (
              this.ficationImgRes.data.name == this.driverLicenseRes.data.name
            ) {
              this.form.ocrResult = 0;
            } else {
              this.form.ocrResult = 1;
            }
          }
          updateDriverTeam(this.form).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
            this.$emit("fatherEditMethod");
          });
        }
      });
    },
    funcCancel() {
      this.$emit("fatherCancelMethod", "edit");
    },
    // 身份证正面识别
    async ficationImgSuccess(url) {
      this.ficationImgRes = {};
      this.ficationImgRes = await getOcr({
        image: url,
        ocrType: "ocrIdidentityCardFront"
      });
      let data = this.ficationImgRes.data;
      data.name ? this.$set(this.form, "name", data.name) : null;
      if (this.ficationImgRes.data) {
        if (data.name != this.driverLicenseRes.name) {
          this.$message({
            message: "上传的身份证与驾驶证姓名不匹配",
            type: "warning"
          });
        }
      }
      data.identity
        ? this.$set(this.form, "identificationNumber", data.identity)
        : null;
      data.address ? this.$set(this.form, "homeAddress", data.address) : null;
      if (data.provinceCode) {
        this.$set(this.form, "provinceCode", data.provinceCode);
        this.$set(this.form, "cityCode", data.cityCode);
        this.$set(this.form, "countyCode", data.countyCode);
        this.$set(this.form, "areaList", [
          data.provinceCode,
          data.cityCode,
          data.countyCode
        ]);
      }
    },
    // 身份证反面识别
    async ficationImgBackSuccess(url) {
      let res = await getOcr({
        image: url,
        ocrType: "ocrIdidentityCardFrontBack"
      });
      let data = res.data;
      if (data.expiryDate == "长期" || data.expiryDate == "9999-12-31") {
        this.$set(this.form, "hasDueDate", true);
        this.$set(this.form, "idCardDueDate", "9999-12-31");
      } else if (data.expiryDate) {
        let time = data.expiryDate.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let expiryDate =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "idCardDueDate", expiryDate);
          this.$set(this.form, "hasDueDate", false);
        }
      }
    },
    // 驾驶证正面识别
    async driverLicenseSuccess(url) {
      this.driverLicenseRes = {};
      this.driverLicenseRes = await getOcr({
        image: url,
        ocrType: "ocrDrivingLicense"
      });
      let data = this.driverLicenseRes.data;
      if (this.driverLicenseRes.msg == "请确认上传驾驶证件是否正确") {
        this.$message({
          message: this.driverLicenseRes.msg,
          type: "warning"
        });
      }
      if (this.ficationImgRes.data) {
        if (data.name != this.ficationImgRes.data.name) {
          setTimeout(() => {
            this.$message({
              message: "上传的驾驶证与身份证姓名不匹配",
              type: "warning"
            });
          }, 1000);
        }
      } else {
        if (this.hisForm.name) {
          if (data.name != this.hisForm.name) {
            setTimeout(() => {
              this.$message({
                message: "上传的驾驶证与身份证姓名不匹配",
                type: "warning"
              });
            }, 1000);
          }
        }
      }
      data.certificateNumber
        ? this.$set(this.form, "driverLicense", data.certificateNumber)
        : null;
      if (data.validStartDate) {
        let time = data.validStartDate.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let validStartDate =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "driverLicenseFromDate", validStartDate);
        }
      }
      if (data.validDate == "长期" || data.validDate == "9999-12-31") {
        this.$set(this.form, "hasDriverDueDate", true);
        this.$set(this.form, "driverLicenseDueDate", "9999-12-31");
      } else if (data.validDate) {
        let time = data.validDate.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let validDate =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "driverLicenseDueDate", validDate);
          this.$set(this.form, "hasDriverDueDate", false);
        }
      }
      this.parentData.vehicleTypeAllowList.map((item, index) => {
        if (item.name == data.canDrivingType) {
          this.$set(this.form, "vehicleClass", data.vehicleClass);
        }
      });
    },
    // 从业资格证识别
    async workLicenseSuccess(url) {
      let res = await getOcr({
        image: url,
        ocrType: "ocrQualificationCertificate"
      });
      let data = res.data;
      data.zhenghao ? this.$set(this.form, "workLicense", data.zhenghao) : null;
      if (data.youxiaoqixian) {
        let time = data.youxiaoqixian.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let value =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "workLicenseDueDate", value);
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.el-date-editor {
  width: 100%;
}
.remarks {
  color: #d01415;
  font-size: 10px;
}
</style>
